export default __webpack_public_path__ + "static/media/kitchen3-afterB-480w.99f671d7.png";